<template>
  <div>
    <div id="Footer" style='z-index: 1000' v-if="$store.state.group_id != 9">
        <div class="logoImg">
          <img :src="`${publicPath}img/samcotec-logo.png`" style="height:20px;margin-top:5px;">
          <div class="timenow">{{ timenow }}</div>
        </div>
        <div><small> 2006-{{ new Date().getFullYear() }} All Rights Reserved to SAMCOTEC</small></div>
        <div style="display:flex;direction:rtl;">
            <div><small>{{$store.state.SystemName}} V {{$store.state.Version}}</small></div>
            
            <div v-if="$store.state.licenseType.demoVersion == false" style="margin:0px 20px 0 20px;cursor: pointer;color:#fff;background:red;padding:5px 20px;" :title="lang.updateprofile" v-b-toggle.password_users @click="Update()">
              <small>{{lang.changePassword}} {{user.full_name}}</small>
            </div>
            <change-password ref="changePassword" />

            <div v-if="(branch != '' || financeYear != '') && ($store.state.licenseType.activemenu =='erp' || $store.state.licenseType.activemenu =='erpsam') " style="display:flex;direction:ltr;background:green;color:#fff;padding-inline:20px;">
              <div v-if="financeYear != ''" style="padding:3px;"> {{ financeYear }} </div>
              <div v-if="financeYear != '' && branch != ''" style="padding:3px;"> | </div>
              <div v-if="branch != ''" style="padding:3px;"> {{ branch }} </div>
            </div>
        </div>
      <!-- <img id="ecarlogo" :src="`${publicPath}img/small-logo-light.png`" style="width:60px;float:right;margin-right:10px;"> -->
    </div>
    <vue-snotify></vue-snotify>
  </div>
</template>
<script>
import changePassword from '@/components/changePassword.vue'
import axios from 'axios'

export default {
  components: {changePassword},
  data() {
    return {
      publicPath: window.location.origin+process.env.BASE_URL,
      user: {},
      branch: '',
      timenow: '',
    }
  },
  computed: {
    financeYear: function(){
      return localStorage.getItem('financeYear')
    },
    
    lang: function(){
          if(this.$cookies.get(this.$store.state.LangCooki) != null){
              if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                return this.$store.state.lang.en;
              }else{
                return this.$store.state.lang.ar;
              }
          }
          else if(this.$store.state.deflang == 'en'){
              return this.$store.state.lang.en;
          }else{
              return this.$store.state.lang.ar;
          }
      },
  },
  methods: {
    getTimeNow(){
        const date = new Date();
        let d = date.getDate();
        d = d < 10 ? "0"+d : d;
        let m = date.getMonth() + 1;
        m = m < 10 ? "0"+m : m;
        const y = date.getFullYear();
        let h = date.getHours();
        let dm = "AM";
        if(h == 0) h = 12;
        else if(h < 10) h = "0"+h;
        else if(h>12){h = parseInt(h) - parseInt(12);dm = "PM"}
        else if(h == 12) {dm = "PM"}

        let min = date.getMinutes();
        min = min < 10 ? "0"+min : min;
        let sec = date.getSeconds();
        sec = sec < 10 ? "0"+sec : sec;
        h = h < 10 ? "0"+h : h;
        // this.timenow = d+"-"+m+"-"+y+" "+h+":"+min+":"+sec+" "+dm;
        this.timenow = d+"-"+m+"-"+y+" "+h+":"+min+" "+dm;
    },
    Update(){
      // console.log();
    },
    getUsers(){
        const post = new FormData();
        post.append('defBranch',localStorage.getItem('defBranch'));
        post.append('financeYear',localStorage.getItem('financeYear'));
        post.append("type" , 'getUsers');
        post.append("auth",this.$cookies.get(this.$COOKIEPhase));
        post.append('data[userid]','current');
        axios.post(
            this.$SAMCOTEC.r_path, post
        ).then(
            (response) => {
                const res = response.data;
                // // console.log(res);
                this.user = res.results.data.results[0];
                this.branch = res.results.branches[`branch_${this.lang.langname}`]
            }
        )
    },
  },
  created() {
    this.getUsers();
    setInterval(()=>{this.getTimeNow()},1000)
  }
}
</script>
<style>
#Footer{
  direction:ltr;
  position: fixed;
  display:flex;
  flex-direction: row;
  justify-content: space-between;
  justify-items: center;
  align-items: center;
  bottom: 0;
  left:0;
  right:0;
  height: 35px;
  background: #e9e9e9;
  border-top:1px solid #ccc;
  padding:5px;
  text-align: center;
}
.logoImg{
  width: 220px;
  display:flex;
  flex-direction: row;
  justify-content: space-between;
  justify-items: center;
  align-items: center;
}
.timenow{
  background:#fff;
  padding:3px;
  width:150px;
  border:1px solid #bbb;
  border-radius: 5px;
}
@media only screen and (max-width: 1000px) {
  .timenow{
    display:none;
  }
  .logoImg{
    display:block;
  }
}
@media only screen and (max-width: 700px) {
  #Footer{
    flex-direction: column;
  }
}
</style>